import { Map } from 'immutable';

import {
  defaultAlertName,

  alertCreateDialogMergeStateReducerType,
  alertCreateDialogResetReducerType,
  alertCreateDialogMergeFormReducerType,
  alertCreateDialogUpdateFormReducerType,
} from './AlertCreateDialogConstatns';

export const initialState = Map({
  alertsInfo: null,
  context: null,
  userTimeZone: null,
  queryFactItem: null,
  description: null,
  structures: null,

  original: Map({
    alertName: undefined,
    databases: [],
  }),

  form: Map({
    alertName: defaultAlertName,
    emails: [],
    frequency: undefined,
    dayOfWeek: undefined,
    dayOfMonth: undefined,
    triggerMode: undefined,
    processOptions: [],
    databases: [],
  }),

  // addition for edit
  alertUuid: null,
  disableEditQuery: null,

  // trackingType for AA
  trackingType: null,

  // show non-owner email message
  showNonOwnerEmailMessage: false,
});


export default function alertCreateDialogsReducer (state = initialState, action) {
  const { payload, type } = action;

  switch(type) {
    case alertCreateDialogMergeStateReducerType: {
      return state.merge(Map(payload));
    }
    case alertCreateDialogResetReducerType: {
      return initialState;
    }
    case alertCreateDialogMergeFormReducerType: {
      return state.update('form', form => form.merge(Map(payload)));
    }
    case alertCreateDialogUpdateFormReducerType: {
      const { key, value } = payload;
      return state.setIn(['form', key], value);
    }
    default: {
      return state;
    }
  }
}
